import { Swiper } from  'swiper'

const HeroCarouselSwiper = () => {
  const heroSections = Array.from(document.querySelectorAll('[swiper-hero-section]'))

  if (heroSections.length < 1 || heroSections === null) return

  heroSections.forEach(section => {
    const swiperContainer = section.querySelector('.swiper')
    if ( !swiperContainer ) return
    const swiper = new Swiper(swiperContainer, {
      loop: true,
      speed: 1000,
      autoplay: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
  })
}

export default HeroCarouselSwiper